import styled from 'styled-components';
import { Spacing } from '../../../theme';
import { DividerProps } from './Divider';

export const Root = styled.div<DividerProps>`
  width: 100%;
  height: 1px;
  background-color: ${(p) =>
    p.backgroundColorTone ? p.theme.colors.grey[p.backgroundColorTone] : p.theme.colors.border.pya};
  margin: ${(p) => (p.spacing ? `${p.theme.spacing[p.spacing]} auto` : 0)};
  @media (max-width: ${(p) => p.theme.screen.md}) {
    margin: ${(p) => p.theme.spacing[reducedSpacing(p.spacing)]})};
  }
  // Shrinking the space twice on mobile.
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    margin: ${(p) => p.theme.spacing[reducedSpacing(reducedSpacing(p.spacing))]} 0;
  }
`;
const reducedSpacing = (spacing?: Spacing): Spacing => {
  if (!spacing || spacing === 'none' || spacing === 'xxs') return 'none';
  if (spacing === 'xl') return 'lg';
  if (spacing === 'lg') return 'md';
  if (spacing === 'md') return 'sm';
  if (spacing === 'sm') return 'xs';
  if (spacing === 'xs') return 'xxs';
};
